import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  Container,
  IconButton,
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FaLinkedinIn } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FiFacebook } from "react-icons/fi";
import { FaXTwitter } from "react-icons/fa6";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { FaWhatsapp } from "react-icons/fa";
import { FaTelegram } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import { CountryFlag } from "../../CommonPage/MarketFlow/CountryFlag";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const countries = [
  { code: "IN", label: "India", flag: "🇮🇳" },
  { code: "US", label: "United States", flag: "🇺🇸" },
  { code: "GB", label: "United Kingdom", flag: "🇬🇧" },
  { code: "CA", label: "Canada", flag: "🇨🇦" },
  { code: "AU", label: "Australia", flag: "🇦🇺" },
  { code: "DE", label: "Germany", flag: "🇩🇪" },
  { code: "FR", label: "France", flag: "🇫🇷" },
  { code: "IT", label: "Italy", flag: "🇮🇹" },
  { code: "ES", label: "Spain", flag: "🇪🇸" },
  { code: "BR", label: "Brazil", flag: "🇧🇷" },
  { code: "ZA", label: "South Africa", flag: "🇿🇦" },
  { code: "CN", label: "China", flag: "🇨🇳" },
  { code: "JP", label: "Japan", flag: "🇯🇵" },
  { code: "KR", label: "South Korea", flag: "🇰🇷" },
  { code: "AE", label: "United Arab Emirates", flag: "🇦🇪" },
  { code: "SG", label: "Singapore", flag: "🇸🇬" },
  { code: "RU", label: "Russia", flag: "🇷🇺" },
  { code: "MX", label: "Mexico", flag: "🇲🇽" },
  { code: "AR", label: "Argentina", flag: "🇦🇷" },
  { code: "NL", label: "Netherlands", flag: "🇳🇱" },
];

const validationSchema = Yup.object({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  email: Yup.string().email("Invalid email").required("Required"),
  phone: Yup.string().required("Phone is required"),
  phone1: Yup.string().required("Country is required"),

  message: Yup.string().required("Message is required"),
});

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [show, setShow] = useState(false);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      phone1: "Lebanon",
      message: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm, setStatus }) => {
      setSubmitted(true);
      try {
        const payload = {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          phone: values.phone,
          phone1: values.phone1,
          message: values.message,
        };

        // ✅ Send to Google Sheets
        await fetch(
          "https://script.google.com/macros/s/AKfycbzjtza7Fn6fB9MisinCUTGpGWimSwVCKBtxx660fBBhhni8bVT0K-x4n9SGQNOxSK6Hqg/exec",
          {
            method: "POST",
            mode: "no-cors", // Google Scripts require no-cors for anonymous
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );

        // ✅ Optional: Also send to EmailJS or another backend here

        setShow(true);
        setSubmitted(false);

        resetForm();
        // setStatus("success");
      } catch (error) {
        setSubmitted(false);

        console.error("Error submitting form:", error);
        alert("Something went wrong. Please try again.");
        // setStatus("error");
        setShow(false);
      }
    },
    // onSubmit: (values, { resetForm }) => {
    //   console.log("Form data", values);
    //   setSubmitted(true);
    //   resetForm();
    //   setTimeout(() => setSubmitted(false), 3000);
    // },
  });

  return (
    <Box px={{ xs: 2, sm: 3, md: 6, lg: 11 }} py={4}>
      <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        gap={6}
      //   alignItems={{ xs: "start", md: "flex-start" }}
      //   textAlign={{ xs: "start", md: "left" }} // ✅ Center text only on small screens
      >
        {/* Left Side */}
        <Box
          flex={1}
          alignItems={{ xs: "center", md: "flex-start" }}
          textAlign={{ xs: "center", md: "left" }} // ✅ Center text only on small screens
        >
          <Typography variant="h2" fontWeight="bold" gutterBottom>
            Want us to
            <br /> contact you?
          </Typography>
          <Typography
            color="text.secondary"
            mb={2}
            fontWeight="500"
            fontSize="22px"
          >
            Leave a message and we will have
            <br /> someone from our team connect with
            <br /> you soon.
            {/* <Typography component="span" color="#19ABE2" fontWeight="bold">
              24/7
            </Typography> */}
          </Typography>
          <Box
            display="flex"
            gap={1}
            sx={{
              justifyContent: { xs: "center", sm: "start" },
              marginLeft: { xs: "0px", sm: "-10px" },
            }}
          >
            <IconButton
              component="a"
              href="https://api.whatsapp.com/send?phone=96178709578"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#25D366", // LinkedIn blue
                  transform: "scale(1.2)",
                },
              }}
              aria-label="whatsapp"
            >
              <FaWhatsapp />
            </IconButton>

            <IconButton
              component="a"
              href="https://www.instagram.com/bbcorpfx/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#E1306C", // Instagram pink
                  transform: "scale(1.2)",
                },
              }}
              aria-label="Instagram"
            >
              <FaInstagram />
            </IconButton>

            <IconButton
              component="a"
              href="https://www.facebook.com/people/BBCorp/100094393060215/?mibextid=wwXIfr&rdid=fkECT0btkzJdCpYx&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BedSuHhZf%2F%3Fmibextid%3DwwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#1877F2", // Facebook blue
                  transform: "scale(1.2)",
                },
              }}
              aria-label="Facebook"
            >
              <FiFacebook />
            </IconButton>
            <IconButton
              component="a"
              href="https://tiktok.com/@bbcorpfx"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#010101", // Instagram pink
                  transform: "scale(1.2)",
                },
              }}
              aria-label="tiktok"
            >
              <FaTiktok />
            </IconButton>
            <IconButton
              component="a"
              href="https://x.com/BBcorpSAL"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#000", // Twitter/X black
                  transform: "scale(1.2)",
                },
              }}
              aria-label="Twitter"
            >
              <FaXTwitter />
            </IconButton>
            <IconButton
              component="a"
              href="https://t.me/bbcorpltd"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#0088CC", // Twitter/X black
                  transform: "scale(1.2)",
                },
              }}
              aria-label="telegram"
            >
              <FaTelegram />
            </IconButton>
          </Box>
        </Box>

        {/* Right Side (Form) */}
        <Box
          flex={2}
          component="form"
          onSubmit={formik.handleSubmit}
          display="flex"
          flexDirection="column"
          gap={2}
        >
          {/* Name Fields */}
          <Box
            display="flex"
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <TextField
              fullWidth
              label="First name"
              name="firstName"
              value={formik.values.firstName}
              onChange={formik.handleChange}
              error={
                formik.touched.firstName && Boolean(formik.errors.firstName)
              }
              helperText={formik.touched.firstName && formik.errors.firstName}
              InputLabelProps={{
                sx: {
                  color: "#667085",
                  fontSize: "16px",
                  fontWeight: "500",
                  marginTop:"-3px",
                  "&.Mui-focused": {
                    color: "#667085",
                  },
                },
              }}
              InputProps={{
                sx: {
                  color: "blue",
                  "& .MuiInputBase-input": {
                    backgroundColor: "rgba(102, 112, 133, 0.1)", // ✅ light grey with opacity
                    padding: "12px 14px", // optional for vertical alignment
                    borderRadius: "8px", // optional: match MUI style
                    fontWeight: 500,
                    fontSize: 16,
                  },
                },
              }}
              FormHelperTextProps={{
                sx: {
                  marginLeft: 0, // ✅ removes default left spacing
                },
              }}
            />
            <TextField
              fullWidth
              label="Last name"
              name="lastName"
              value={formik.values.lastName}
              onChange={formik.handleChange}
              error={formik.touched.lastName && Boolean(formik.errors.lastName)}
              helperText={formik.touched.lastName && formik.errors.lastName}
              InputLabelProps={{
                sx: {
                  color: "#667085",
                  fontSize: "16px",
                  fontWeight: "500",  
                  marginTop:"-3px",
                  "&.Mui-focused": {
                    color: "#667085",
                  },
                },
              }}
              InputProps={{
                sx: {
                  color: "blue",
                  "& .MuiInputBase-input": {
                    backgroundColor: "rgba(102, 112, 133, 0.1)", // ✅ light grey with opacity
                    padding: "12px 14px", // optional for vertical alignment
                    borderRadius: "8px", // optional: match MUI style
                    fontWeight: 500,
                    fontSize: 16,
                  },
                },
              }}
              FormHelperTextProps={{
                sx: {
                  marginLeft: 0, // ✅ removes default left spacing
                },
              }}
            />
          </Box>

          {/* Email */}
          <Box
            display="flex"
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            {/* Email */}
            <Box sx={{ flex: 1 }}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                InputLabelProps={{
                  sx: {
                    color: "#667085",
                    fontSize: "16px",
                    fontWeight: "500",
                    marginTop:"-3px",
                    "&.Mui-focused": {
                      color: "#667085",
                    },
                  },
                }}
                InputProps={{
                  sx: {
                    color: "blue",
                    "& .MuiInputBase-input": {
                      backgroundColor: "rgba(102, 112, 133, 0.1)", // ✅ light grey with opacity
                      padding: "12px 14px", // optional for vertical alignment
                      borderRadius: "8px", // optional: match MUI style
                      fontWeight: 500,
                      fontSize: 16,
                    },
                  },
                }}
                FormHelperTextProps={{
                  sx: {
                    marginLeft: 0, // ✅ removes default left spacing
                  },
                }}
              />
            </Box>

            {/* Phone with Country Code */}
            <Box sx={{ flex: 1 }}>
              <PhoneInput
                country={"lb"}
                value={formik.values.phone}
                onChange={(phone) => formik.setFieldValue("phone", phone)}
                inputStyle={{
                  width: "100%",
                  height: "48px",
                  fontSize: "0.9rem",
                  paddingLeft: "48px",
                  paddingLeft: "60px",
                  backgroundColor: "rgba(102, 112, 133, 0.1)", // ✅ background color
                  border: "1px solid #ccc", // optional border
                  borderRadius: "8px",
                }}
                buttonStyle={{
                  height: "48px", // match input
                  backgroundColor: "rgba(102, 112, 133, 0.1)", // ✅ background for flag area
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                }}
                containerStyle={{
                  width: "100%",
                  backgroundColor: "transparent", // leave transparent to avoid override
                }}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
                specialLabel=""
              />
              {formik.touched.phone && formik.errors.phone && (
                <Typography variant="caption" color="error">
                  {formik.errors.phone}
                </Typography>
              )}
            </Box>
            <Box sx={{ flex: 1 }}>
              <Select
                fullWidth
                name="phone1"
                value={formik.values.phone1}
                onChange={formik.handleChange}
                IconComponent={() => null}
                sx={{
                  height: 48, // ✅ consistent height
                  fontWeight: 500,
                  fontSize: "18px",
                  backgroundColor: "rgba(102, 112, 133, 0.1)",
                  display: "flex",
                  alignItems: "center",
                  pl: 0, // prevent double padding
                }}
                renderValue={(selected) => {
                  const country = CountryFlag.find((c) => c.name === selected);
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "stretch", // ✅ children stretch to full height
                        height: "100%",
                      }}
                    >
                      {/* 🔴 Red background container */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "rgba(102, 112, 133, 0.1)",
                          padding: "13px",
                          marginLeft: "-13px",
                          borderTopLeftRadius: "8px",
                          borderBottomLeftRadius: "8px",
                          px: 1.5,
                          // borderRight: "1px solid #ccc",
                          height: "100%", // ✅ match full height of Select
                        }}
                      >
                        <img
                          src={country?.flag}
                          alt={country?.name}
                          style={{
                            width: 24,
                            height: 24,
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                        <KeyboardArrowDownIcon sx={{ fontSize: 20, ml: 1 }} />
                      </Box>

                      {/* Country name */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          px: 2,
                        }}
                      >
                        <Typography sx={{ fontWeight: 400, fontSize: "15px",fontFamily: "SF Pro Display",}}>
                          {country?.name}
                        </Typography>
                      </Box>
                    </Box>
                  );
                }}
              >
                {CountryFlag.map((c) => (
                  <MenuItem
                    key={c.name}
                    value={c.name}
                    sx={{
                      fontSize: "15px",
                      fontWeight: 500,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={c.flag}
                      alt={c.name}
                      style={{
                        width: 24,
                        height: 24,
                        objectFit: "cover",
                        marginRight: 8,
                      }}
                    />
                    {c.name}
                  </MenuItem>
                ))}
              </Select>

              {formik.touched.phone1 && formik.errors.phone1 && (
                <Typography variant="caption" color="error">
                  {formik.errors.phone1}
                </Typography>
              )}
            </Box>

            {/* Country Dropdown */}
          </Box>

          {/* Message */}
          <TextField
            fullWidth
            multiline
            minRows={4}
            name="message"
            label="Leave your message..."
            value={formik.values.message}
            onChange={formik.handleChange}
            error={formik.touched.message && Boolean(formik.errors.message)}
            helperText={formik.touched.message && formik.errors.message}
            InputLabelProps={{
              sx: {
                color: "#667085",
                fontSize: "16px",
                fontWeight: 500,
                "&.Mui-focused": {
                  color: "#667085",
                },
              },
            }}
            InputProps={{
              sx: {
                color: "blue",
                backgroundColor: "rgba(102, 112, 133, 0.1)", // ✅ matching background
                borderRadius: "8px",
                padding: "12px", // optional: makes text not hug the edge
                fontWeight: 500,
                fontSize: 16,
              },
            }}
            FormHelperTextProps={{
              sx: {
                marginLeft: 0, // ✅ removes default left spacing
              },
            }}
          />

          {/* Submit */}
          {show && (
            <Grid item xs={12}>
              <Typography variant="body2" color="rgba(89, 175, 153, 1)" style={{ fontSize: '16px' }} fontWeight="500">
                Thank you we’ll get back to you soon.
              </Typography>
            </Grid>
          )}
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            {/* {submitted && ( */}
            {/* <Typography variant="body2" color="rgba(89, 175, 153, 1)" style={{fontSize:'14px'}} fontWeight="400">
               Thank you we’ll get back to you soon.
              </Typography> */}
            {/* )} */}
            <Button
              type="submit"
              sx={{
                background: "#19ABE2",
                color: "#fff",
                width: "160px", // ✅ fixed size
                borderRadius: "8px", // optional
                textTransform: "none", // optional: avoid ALL CAPS
                // "&:hover": {
                //   background: "transparent", // subtle hover color
                // },
              }}
            >
              {submitted ? "Submitting..." : "Submit"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactForm;
